import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';

import { IInterviewData } from '../../../models/dashboard/jobs/singleJobApplicants.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';

const useGetJobInterviews = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [interviews, setInterviews] = useState<IInterviewData[] | null>(null);

  const onGetJobInterviewSuccess = useCallback(
    ({ data, message }: SuccessHttpResponse<IInterviewData[]>) => {
      console.log('Job Interviews:', data, message);
      setInterviews(data);
    },
    []
  );

  const onGetJobInterviewError = useCallback(
    (err: AxiosError<ErrorHttpResponse>) => {
      console.error(
        err?.message ?? 'Something went wrong while fetching job interviews'
      );
    },
    []
  );

  const getJobInterviews = useCallback(
    (jobId: string) => {
      const url: HttpConfig = {
        url: `jobs-service/jobs/${jobId}/interviews`,
        method: 'get',
      };

      return request(
        url,
        onGetJobInterviewSuccess,
        setLoading,
        onGetJobInterviewError
      );
    },
    [request, onGetJobInterviewSuccess, onGetJobInterviewError]
  );

  return { getJobInterviews, loading, interviews };
};

export default useGetJobInterviews;
